import { css, keyframes } from 'styled-components';

import { styledLayout } from './layout';
import { floorGameDuration as duration } from './motion';

const skeletonColor = {
    background: `linear-gradient(134deg, transparent, black)`,
    foreground: `linear-gradient(90deg, transparent, white, transparent)`,
};

const shimmerAnimation = keyframes`
    0%,
    20% {
        opacity: 0;
        scale: 1 1;
        translate: -100%;
    }

    50% {
        opacity: 0.1;
        scale: 2 1;
    }

    80%,
    100% {
        opacity: 0;
        scale: 1 1;
        translate: 100%;
    }
`;

const shineAnimation = keyframes`
    to {
        opacity: 0.2;
    }

    from {
        opacity: 0.26;
    }
`;

const baseStyles = css`
    position: relative;
    overflow: hidden;
    background: ${skeletonColor.background};
    opacity: 0.4;

    &::before {
        ${styledLayout.positionCover()}
        content: '';
        background: ${skeletonColor.foreground};
        animation: ${shimmerAnimation} ${duration.crawl * 4}ms ease-in-out infinite both;
    }

    &::after {
        ${styledLayout.positionCover()}
        content: '';
        background-color: white;
        animation: ${shineAnimation} ${duration.crawl}ms ease-in-out alternate infinite both;
    }
`;

const thumbnailStyles = css`
    ${baseStyles};
    width: 100%;
    height: 100%;
    border-radius: 50%;
`;

export const styledSkeleton = {
    skeletonColor,
    shimmerAnimation,
    shineAnimation,
    baseStyles,
    thumbnailStyles,
};
